import React from "react";
import styles from "../styles/Header.module.css";

const SpeakingPage = () => (
  <div className={styles.page}>
    <section className={styles.speaking}>
      <div className={styles.sectionWrap}>
        <h2 className={styles.sectionHeading}>Speaking</h2>
        <div className={styles.talkList}>
          <div className={styles.talkRow}>
            <span className={styles.talkYear}>2025</span>
            <div className={styles.talkMain}>
              <h3 className={styles.talkTitle}>
                Grounded in Green: Green Software in Practise
              </h3>
              <p className={styles.talkEvent}>Agilists4Planet 2025 - Canada</p>
              <div className={styles.talkLinks}>
                <a
                  href="https://www.linkedin.com/feed/update/urn:li:activity:7366509513895477248/"
                  target="_blank"
                  rel="noreferrer"
                  className={styles.projLink}
                >
                  LinkedIn ↗
                </a>
              </div>
            </div>
          </div>

          <div className={styles.talkRow}>
            <span className={styles.talkYear}>2024</span>
            <div className={styles.talkMain}>
              <h3 className={styles.talkTitle}>
                Building Sustainable Digital Products
              </h3>
              <p className={styles.talkEvent}>DevFest Lagos 2024 — GDG Lagos</p>
              <div className={styles.talkLinks}>
                <a
                  href="https://drive.google.com/file/d/1LAX7O9ty4ElbQG-6W7OqN8l8Pen0D_h7/view"
                  target="_blank"
                  rel="noreferrer"
                  className={styles.projLink}
                >
                  Watch ↗
                </a>
              </div>
            </div>
          </div>

          <div className={styles.talkRow}>
            <span className={styles.talkYear}>2024</span>
            <div className={styles.talkMain}>
              <h3 className={styles.talkTitle}>
                What is Green Software, from a Frontend Engineer's Perspective
              </h3>
              <p className={styles.talkEvent}>
                She Code Africa — Mid-Year Tech Symposium
              </p>
              <div className={styles.talkLinks}>
                <a
                  href="https://www.youtube.com/watch?v=v9gZPL6cOnc"
                  target="_blank"
                  rel="noreferrer"
                  className={styles.projLink}
                >
                  Watch ↗
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
);

export default SpeakingPage;
